import * as React from "react";
import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';

const NameChangeHistoryField = (props) => {
    const record = useRecordContext(props);
    const nameChangeHistoryLink = `/submissions?filter={"source_url":"/events/ticket-update/?submission_id=${record.submission_id}%26ticket_number=${record.ticket_number}"}`;
    return ( <Link to={nameChangeHistoryLink}>{record.name_change_count}</Link> );
}

NameChangeHistoryField.defaultProps = { label: 'Name Changes' };

export default NameChangeHistoryField;
